import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { VerifyResponse } from '@app/models/offers/VerifyResponse';
import { TVAngebot } from '@app/models/sktv/TVAngebot';
import { Subject } from 'rxjs';
import { formatNumber } from '@angular/common';
import { TvangebotimagevideoComponent } from '@app/components/modals/tvangebotimagevideo/tvangebotimagevideo.component';

@Component({
    selector: 'clever-sktv-detail',
    templateUrl: './sktv-detail.component.html',
    styleUrls: ['./sktv-detail.component.scss'],
    standalone: false
})
export class SktvDetailComponent implements OnInit, OnDestroy {
    @Input() booking: VerifyResponse;
    @Input() sktvContent: TVAngebot;
    @Output() sendAlt: EventEmitter<boolean> = new EventEmitter();
    @Output() sendBook: EventEmitter<boolean> = new EventEmitter();
    private unsubscribe$ = new Subject();

    deskMode: boolean = true;
    showMap: boolean = false;

    travelerText: string = '';
    prcdetail: string = '';
    desktopTemplate: string = '';

    curentContent: number = 0;
    constructor(
        protected mediaObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog
    ) {
    }

    ngOnInit(): void {
        this.initMedia();
        this.initPrcData();
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
            this.deskMode = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
            this.deskMode = true;
        }
    }

    async initPrcData () {
        let countEr = 1;
        let kind = 0;
        let erw = 0;
        for (let i = 0; i < this.booking?.travellerList?.length; i++) {
            let prc = ''
            if (this.booking.travellerList[i].price?.value?.length > 0) {
                prc = formatNumber(Number(this.booking.travellerList[i].price?.value), 'de-DE', '1.2-2');
            } else {
                if (this.booking.travellerList[i].type === 'H') {
                    prc = formatNumber(Number(this.booking.pricePerPerson?.value), 'de-DE', '1.2-2');
                } else {
                    prc = '?';
                }
            }
            if (prc?.length > 0) {
                if (this.booking.travellerList[i].type === 'H') {
                    this.prcdetail += countEr + '.Erwachsener ' + prc + ' EUR<br>';
                    countEr++;
                    erw += 1;
                } else {
                    this.prcdetail += countEr + '.Kinder ' + prc + ' EUR<br>';
                    countEr++;
                    kind += 1;
                }
            }
        }
        if (erw > 0) {
            this.travelerText = erw + ' Erwachsene';
        }
        if (kind > 0) {
            this.travelerText += ', ' + kind + ' Kinder';
        }
        this.cdr.detectChanges();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    sendAalternative() {
        this.sendAlt.emit(true);
    }

    sendBooking() {
        this.sendBook.emit(true);
    }

    async openImageModal (ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: this.sktvContent,
                images: this.sktvContent.images,
                videos: [],
                current: ev,
                to800: true,
                desktopTemplate: this.desktopTemplate
            }
        }
        this.dialog.open(TvangebotimagevideoComponent, target);
    }
}
